module.exports = __webpack_public_path__ + "static/village_card_img6@2x-9837035aa58bf128fa09a8ce49c9460e.png";